module.exports = __webpack_public_path__ + "img/dcx.bce0ef24.jpg";